import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiHelperService } from '../../core/api-helper.service';
import { BillingInfo } from './billing-info.model';

@Injectable({
    providedIn: 'root'
})
export class BillingInfoService {

    private options = { authenticate: true, setRoot: true };

    constructor( private api: ApiHelperService) {}

    get(filter: Partial<BillingInfo>): Promise<BillingInfo|undefined> {
        return this.api.apiCallSane(
            '/billing-info',
            'GET',
            this.api.getDefaultHeaders(),
            filter,
            null,
            this.options)
        .then(pbi => pbi != null ? new BillingInfo(pbi) : null);
    }

    getBillingInfoById(id:string): Promise<BillingInfo> {
        return this.api.apiCallSane(
            '/billing-info',
            'GET',
            this.api.getDefaultHeaders(),
            { id },
            null,
            this.options
        );
    }

    // TODO - leave this in for now so we can reference connecting with NMI
    // createBillingInfoCustomer(data: Partial<BillingInfo> & { payment_token: string }): Promise<BillingInfo> {
    createBillingInfoCustomer(data: Partial<BillingInfo> & { paymentMethodId: string }): Promise<BillingInfo> {
        const headers: HttpHeaders = this.api.getDefaultHeaders();
        return this.api.apiCallSane(
            '/billing-info',
            'PUT',
            headers,
            null,
            data,
            this.options
        );
    }

    createGatewayCustomer(data: { customerId?: string, emailAddress: string, firstName: string, lastName: string, phone: string }): Promise<{ id: string }> {
        return this.api.apiCallSane(
            '/billing-info/gateway-customer',
            'POST',
            this.api.getDefaultHeaders(),
            null,
            data, 
            this.options);
    }

    createCustomerAndChargeInitialBill(data: Partial<BillingInfo>) {
        const headers: HttpHeaders = this.api.getDefaultHeaders();
        return this.api.apiCallSane('/billing-info/initial-charge', 'PUT', headers, null, data, this.options);
    }

    deleteBillingInfo(id: string) {
        return this.api.apiCallSane(
            '/billing-info',
            'DELETE',
            this.api.getDefaultHeaders(),
            { id },
            null,
            this.options);
    }
}

